<div class="filter-body-wrapper">
    <mat-form-field appearance="fill">
        <mat-icon matPrefix class="search-icon" svgIcon="search"></mat-icon>
        <input
            #input
            [value]="filterValue$.value"
            type="text"
            matInput
            [placeholder]="'Search...' | translate"
            (input)="filterValue$.next(input.value)"
        />
    </mat-form-field>
</div>
<app-filter-apply-panel
    [applyButtonDisabled]="applyButtonDisabled"
    [resetButtonDisabled]="resetButtonDisabled"
    (applyButtonClick)="updateFilter()"
    (resetButtonClick)="resetFilter()"
    [columnName]="params?.colDef.headerName"
></app-filter-apply-panel>
